// extracted by mini-css-extract-plugin
export default {"chart":"bj_Ph","fullscreen":"bj_dS","close":"bj_qh"};